var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataScatterFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data Scatter Filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.125C2.5 2.77982 2.77982 2.5 3.125 2.5C3.47018 2.5 3.75 2.77982 3.75 3.125V16.25H16.875C17.2202 16.25 17.5 16.5298 17.5 16.875C17.5 17.2202 17.2202 17.5 16.875 17.5H3.125C2.77982 17.5 2.5 17.2202 2.5 16.875V3.125Z",
    fill: "#1D72E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83333C11.6667 4.45262 12.786 3.33333 14.1667 3.33333C15.5474 3.33333 16.6667 4.45262 16.6667 5.83333C16.6667 7.21405 15.5474 8.33333 14.1667 8.33333C12.786 8.33333 11.6667 7.21405 11.6667 5.83333Z",
    fill: "#1D72E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C6.11929 5 5 6.11929 5 7.5C5 8.88071 6.11929 10 7.5 10C8.88071 10 10 8.88071 10 7.5C10 6.11929 8.88071 5 7.5 5Z",
    fill: "#1D72E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C11.1193 10 10 11.1193 10 12.5C10 13.8807 11.1193 15 12.5 15C13.8807 15 15 13.8807 15 12.5C15 11.1193 13.8807 10 12.5 10Z",
    fill: "#1D72E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScatterFilled);
export default __webpack_public_path__ + "static/media/data_scatter_filled.2c58551774062ab9059f68e5d4276e0d.svg";
export { ForwardRef as ReactComponent };